import React from 'react';
import { useIntl, history } from 'umi';
import { useDebounceFn } from 'ahooks';
import SvgIcon from '@/pages/home/components/SvgIcon';
import EllipsisHover from '@/pages/home/components/EllipsisHover';
import GameImage from '@/pages/home/components/GameImage';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import { getGameIdByEntityGamePath } from '../../../utils';
import type { IPCConsoleGame } from '@/pages/intelligence/types/pcConsoleCompare';
import './index.scss';
import ARightClickToJump from '@/pages/intelligence/components/ARightClickToJump';

export default function PCUHeaderColumnRender(pageKey: string, entity: IPCConsoleGame) {
  const { formatMessage } = useIntl();

  const entityType = entity?.entityType?.toLowerCase() || 'pc';
  const hasPC = entityType?.includes('pc');

  const getGameDetailPath = (entityType: 'pc' | 'console'| 'combine') =>{
    const gameId = getGameIdByEntityGamePath(entity, entityType);
    const path = getDetailGamePathCommon({
      entityType,
      gameId,
      tab: 'stats',
      subTab: pageKey || 'pcu',
    });
    return path;
  }

  const { run: handleNavigate2GameDetailsPageClick } = useDebounceFn(
    (entityType: 'pc' | 'console' | 'combine', e: React.SyntheticEvent<HTMLElement>) => {
      e?.stopPropagation();
      e?.preventDefault();
      history.push(getGameDetailPath(entityType));
    },
    { wait: 300 },
  );

  return (
    <div className="dbi_header-column-content dbi_pc_header-column-content">
      <div className="dbi_header-column-content-inner">
        {hasPC && (
          <>
            <div className="dbi_game-cover-list">
              <div
                className="dbi_game-cover-item"
                onClick={(e) => {
                  e?.persist();
                  handleNavigate2GameDetailsPageClick('pc', e);
                }}
              >
                <GameImage
                  className="dbi_game-cover pc-console-cover dbi-cursor"
                  src={entity?.pcCover}
                  entityType="pc"
                  alt=""
                />
              </div>
            </div>
            <div className="dbi_game-summary">
              <ARightClickToJump
                href={getGameDetailPath('combine')}
                style={{display: 'flex'}}
              >
              <div
                className="dbi_game-name dbi-cursor"
                onClick={(e) => {
                  e?.persist();
                  handleNavigate2GameDetailsPageClick('combine', e);
                }}
              >
                <EllipsisHover text={entity?.gameName || '-'} />
              </div>
              <SvgIcon
                className="dbi-add-entities-first-row-comp_platform-icon dbi-cursor"
                type="monitor"
                onClick={(e) => {
                  e?.persist();
                  handleNavigate2GameDetailsPageClick('pc', e);
                }}
              />
            </ARightClickToJump>
            </div>
          </>
        )}
        {hasPC || (
          <>
            <ARightClickToJump
              href={getGameDetailPath('console')}
            >
            <div
              className="dbi_game-name no-mr dbi-cursor"
              onClick={(e) => {
                e?.persist();
                handleNavigate2GameDetailsPageClick('console', e);
              }}
            >
              <EllipsisHover text={entity?.gameName || '-'} />
            </div>
            </ARightClickToJump>
            <div className="dbi_game-tips">
              {formatMessage({ id: 'dbi_compare_no_pc_version_tips' })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
